import { createAppSelector, RootState } from "../configureStore";
import { StreamState } from '../reducers/stream';

const stateSelector = (state: RootState) => state.stream;

const makeStreamSelector = () =>
  createAppSelector(
    stateSelector,
    (_: StreamState, name: string) => name,
    (streams: StreamState, name: string) => streams[name],
  );

export default makeStreamSelector;
